var render = function render(){var _vm=this,_c=_vm._self._c;return (!isNaN(_vm.params.value))?_c('div',{staticClass:"cell-render-currency"},[_vm._v(" "+_vm._s(_vm._f("formatNumber")(_vm.params.value))+" € ")]):_c('div',{staticClass:"cell-render-currency"},[_vm._v(" "+_vm._s(_vm.params.value)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }